<template>
    <div>
        <div v-for="(source, index) in sources" :key="index">
            <div class="domain-reviews-container mb-4">
                <div class="header">
                    <div class="image-domain-name">
                        <div class="image"
                             :style="{ backgroundImage: 'url(' + source.logo + ')' }"></div>
                        <div class="domain-name">
                            <h4 style="color: #7f9741;">{{ source.name ? source.name : defaultSourceName }}</h4>
                        </div>
                    </div>
                    <div v-if="source.averageReviews > 0 && source.totalReviews > 0" class="rating">
                        <strong>{{ source.averageReviews.toFixed(1) }}</strong> ★ {{ translations.from }} {{
                        source.totalReviews }}
                        {{ translations.reviews }}
                    </div>
                </div>
                <div class="body">
                    <div v-for="review in source.reviews" class="review-wrapper"
                         :class="{'centered': !review.comment}">
                        <div v-if="review.user && review.user.id !== 21" class="image-container">
                            <a v-if="review.user.username" :href="getUserUrl(review.user.username)" rel="nofollow">
                                <div class="image"
                                     :style="'background-image: url('+review.user.image+')'"></div>
                            </a>
                            <div v-else-if="review.user.image" class="image"
                                 :style="'background-image: url('+review.user.image+')'"></div>
                            <div class="review-info">
                                <a v-if="review.user.username" :href="getUserUrl(review.user.username)" rel="nofollow">
                                    <h5>{{ review.user.username }}</h5>
                                </a>
                                <div v-if="review.formatted_date">{{ review.formatted_date }}</div>
                            </div>
                            <star-rating v-if="review.rating > 0"
                                         active-color="#FFD54F"
                                         :read-only="true"
                                         :rating="review.rating"
                                         :show-rating="false"
                                         :inline="true"
                                         :star-size="20"
                                         :round-start-rating="false">
                            </star-rating>
                            <div class="ml-8">
                                <span class="lnr lnr-flag report-feedback" :title="translations.report_review" @click="reportFeedback(review)"></span>
                            </div>
                        </div>
                        <div v-else class="image-container">
                            <star-rating v-if="review.rating > 0"
                                         active-color="#FFD54F"
                                         :read-only="true"
                                         :rating="review.rating"
                                         :show-rating="false"
                                         :inline="true"
                                         :star-size="20"
                                         :round-start-rating="false">
                            </star-rating>
                            <div class="ml-8">
                                <span class="lnr lnr-flag report-feedback" :title="translations.report_review" @click="reportFeedback(review)"></span>
                            </div>
                        </div>
                        <div class="text">
                            <span v-if="review.comment">
                                <p>{{ stripHtml(review.comment).substring(0, 160) }}</p>
                                <span v-if="review.comment.length > 160">
                                    <a v-if="review.url"
                                       :href="review.url" target="_blank" class="read-more-btn">{{ translations.read_more }}</a>
                                    <a v-else
                                       @click="readMore"
                                       :data-full-text="stripHtml(review.comment)"
                                       href="javascript:void(0);" class="read-more-btn">{{ translations.read_more }}</a>
                                </span>
                                <br>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="source.has_feedback && !main_page" class="domain-reviews-footer">
                    <button @click="loadMoreReviews(source)"
                            class="btn btn-primary"
                            :class="{'hidden-button': source.all_reviews.length <= reviewsLimit || source.reviews.length >= source.all_reviews.length}">
                        {{ translations.more_reviews }}
                    </button>
                    <small>{{ translations.last_update }}: {{ source.latestUpdate }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sources_route: {
            type: String,
            required: true
        },
        main_page: {
            type: Boolean,
            default: false
        },
        main_page_limit: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            reviewsRoute: '',
            reportRoute: '',
            feedbackTabRoute: '',
            sources: [],
            reviewsLimit: 3,
            defaultSourceName: '',
            translations: {},
        }
    },
    methods: {
        getFeedbackSources() {
            axios.get(this.sources_route)
                .then((response) => {

                    this.reviewsRoute = response.data.reviews_route;
                    this.reportRoute = response.data.report_route;
                    this.feedbackTabRoute = response.data.feedback_tab_route;
                    this.defaultSourceName = response.data.default_source_name;
                    this.translations = response.data.translations;

                    let sourcesList = response.data.feedback_sources;

                    let localFeedbackIndex = sourcesList.indexOf(null);

                    if (localFeedbackIndex !== -1) {
                        sourcesList = this.moveArrayItemToNewIndex(sourcesList, localFeedbackIndex, sourcesList.length - 1);
                    }

                    for (let i = 0; i < sourcesList.length; i++) {

                        let totalReviews = 0;
                        let averageReviews = 0;

                        if (sourcesList[i].rating_count) {
                            totalReviews = sourcesList[i].rating_count;
                        }

                        if (sourcesList[i].rating_average) {
                            averageReviews = sourcesList[i].rating_average;
                        }

                        let source = {
                            name: sourcesList[i].name,
                            logo: sourcesList[i].logo ? sourcesList[i].logo : '/assets/img/favicons/favicon-57x57.png',
                            skip: 0,
                            take: this.reviewsLimit,
                            reviews: [],
                            all_reviews: [],
                            totalReviews: totalReviews,
                            averageReviews: averageReviews,
                            latestUpdate: null,
                            firstFetch: true,
                            companyUrl: null,
                            has_feedback: sourcesList[i].has_feedback
                        };

                        this.sources.push(source);

                        if (sourcesList[i].has_feedback && (this.main_page && i === 0 || !this.main_page)) {
                            this.getReviews(source);
                        }
                    }
                });
        },
        getReviews(source) {
            axios.get(
                this.reviewsRoute + '/?first-fetch=' + source.firstFetch + '&source=' + source.name + '&skip=' + source.skip + '&take=' + source.take
            )
                .then((response) => {
                    let comments = response.data.comments.map(function (item) {
                        if (item.comment === null) {
                            item.comment = item.old_comment;
                        }

                        return item;
                    });

                    source.all_reviews.push(...comments);

                    if (!source.totalReviews) {
                        source.totalReviews = response.data.totalReviews;
                    }

                    if (!source.averageReviews) {
                        source.averageReviews = response.data.averageReviews;
                    }

                    source.latestUpdate = response.data.latestUpdate;

                    if (source.firstFetch) {
                        if (response.data.comments.length > 0) {
                            let firstComment = response.data.comments[0];

                            if (firstComment.sources) {
                                let sourcesUrl = firstComment.sources.split(',');

                                let sourceName = new RegExp(source.name, 'i');

                                let sourceUrl = sourcesUrl.filter(function (el) {
                                    return el.search(sourceName) > -1;
                                });

                                if (sourceUrl.length > 0) {
                                    source.companyUrl = sourceUrl[0];
                                }
                            }
                        }

                        source.firstFetch = false;
                    }

                    this.loadMoreReviews(source);
                });
        },
        loadMoreReviews(source) {
            let end = source.skip + source.take;

            let reviews = source.all_reviews.slice(source.skip, end);

            source.reviews.push(...reviews);

            source.skip += source.take;

            this.addReadMoreToTab(source);
        },
        reportFeedback(feedback) {
            axios.post(
                this.reportRoute,
                {
                    feedback: feedback
                })
                .then((response) => {
                    if (response.data.code === 'red') {
                        iziToast.show({
                            title: response.data.message,
                            color: response.data.code  // blue, red, green, yellow
                        });

                        return;
                    }

                    location.href = response.data.redirect_url;
                });
        },
        moveArrayItemToNewIndex(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                let k = new_index - arr.length + 1;

                while (k--) {
                    arr.push(undefined);
                }
            }

            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

            return arr;
        },
        stripHtml(string) {
            return string.replace(/(<([^>]+)>)/gi, "");
        },
        addReadMoreToTab(source) {
            if (source.totalReviews <= 0 || !this.main_page) {
                return;
            }

            let readMoreHeight = this.sources.length > 1 ? 410 : 310;

            this.$nextTick(() => {
                window.readMore(
                    $('#reviews-container'),
                    '<a href="' + this.feedbackTabRoute + '" class="btn btn-primary">' + this.translations.tabbing_read_more + '</a>',
                    readMoreHeight
                );
            });
        },
        readMore(event) {
            let originalText = $(event.target).attr('data-full-text');

            $(event.target).parent().parent().find('p').text(originalText);
            $(event.target).remove();
        },
        getUserUrl(username) {
            return window.location.protocol + "//" + window.location.hostname + "/user/" + username;
        },
    },
    mounted() {
        if (this.main_page) {
            this.reviewsLimit = this.main_page_limit;
        }

        this.getFeedbackSources();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FeedbackV2.vue